import { provideChameleonDesignSystem } from '@getgo/chameleon-toolkit';
import { chameleonTooltipV3 } from './TooltipV3.definition';
provideChameleonDesignSystem().register(chameleonTooltipV3());
